'use client'

import Link from 'next/link'
import { SALE_SECTION_CONFIG, type SaleSectionSlug } from '@/saleSections'
import { useSaleFilterController } from './hooks'

type FilterCard = {
  slug: SaleSectionSlug
  label: string
  image: string
}

const FEATURED_SLUGS: SaleSectionSlug[] = [
  'magic-tricks',
  'magic-books',
  'ebooks',
  'downloads',
]

const FEATURED_FILTERS: FilterCard[] = FEATURED_SLUGS.map(slug => ({
  slug,
  label: SALE_SECTION_CONFIG[slug].cardLabel,
  image: SALE_SECTION_CONFIG[slug].cardImage,
}))

const ALL_DISCOUNTS_CARD: FilterCard = {
  slug: 'all',
  label: SALE_SECTION_CONFIG.all.cardLabel,
  image: SALE_SECTION_CONFIG.all.cardImage,
}

const FilterHeaderSection = () => {
  const { slug, getCategoryHref } = useSaleFilterController()

  const visibleCards =
    slug === 'all'
      ? FEATURED_FILTERS
      : [
          ...FEATURED_FILTERS.filter(card => card.slug !== slug).slice(0, 3),
          ALL_DISCOUNTS_CARD,
        ]

  return (
    <div className="pb-6 pt-4">
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        {visibleCards.map(card => (
          <Link
            key={card.slug}
            href={getCategoryHref(card.slug)}
            className="group flex flex-col text-left"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden rounded-md">
              <img
                src={card.image}
                alt={card.label}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover transition duration-200 group-hover:scale-105"
              />
            </div>
            <span
              className={`mt-3 text-lg font-semibold ${
                slug === card.slug ? 'text-red-600' : 'text-gray-900'
              }`}
            >
              {card.label}
            </span>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default FilterHeaderSection
